//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from '@material-ui/core/styles';

export const authPageStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
}));

export const dashboardStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '@media (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  sidebarOne: {
    width: '33%',
    display: 'block',
    '@media (max-width: 768px)': {
      background: 'white',
      zIndex: 200,
      width: '100%',
    },
    '@media (max-width: 600px)': {
      width: '100%',
    },
  },
  sidebarTwo: {
    width: '33%',
    '@media (max-width: 768px)': {
      width: '100%',
      background: 'white',
      zIndex: 200,
    },
  },
  dashboard: {
    padding: '10px !important',
    overflow: 'auto',
    width: '100%',
    marginBottom: 100,
  },
  dashboardOne: {
    padding: '10px !important',
    overflow: 'hidden',
    width: '100%',
  },
  HSBanner: {
    '@media (max-width: 768px)': {
      display: 'none',
    },
  },
  bannerText: {
    marginTop: 5,
    textAlign: 'center',
    color: 'red',
    fontWeight: 'bold',
    fontSize: 15,
  },
  // Dialog
  dialogParentDiv: {
    padding: 25,
  },
  parentText: {
    fontSize: 25,
  },

  proceedBtnGrid: {
    textAlign: 'right',
  },
  proceedBtn: {
    color: '#fff',
    backgroundColor: '#305698',
    borderRadius: 10,
    fontSize: 20,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#305698',
    },
  },
  noBtn: {
    color: '#305698',
    backgroundColor: '#fff',
    border: '2px solid #305698',
    borderRadius: 10,
    fontSize: 20,
    textTransform: 'capitalize',
  },
  subParentText: {
    color: '#595959',
    fontSize: 20,
  },
  logoutBtn: {
    border: 'none',
    color: '#fff',
    backgroundColor: '#0a72ba !important',
    padding: '0px 5px',
    borderRadius: 3,
    marginBottom: 5,
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  language: {
    color: 'inherit',
    fontStyle: '12px',
    cursor: 'pointer',
    padding: '10px 10px',
  },
  // backBtn: {
  //   border: "none",
  //   backgroundColor: "#0a72ba",
  //   color: "#fff",
  //   borderRadius: "5px",
  //   marginTop: -12,
  //   marginBottom: 20,
  //   cursor: "pointer",
  //   padding: "4px 8px",
  //   "&:hover":{
  //     backgroundColor: "#0a72ba",
  //   }
  // },
}));
